import React, { useEffect } from 'react'
import DataTable from '../datatable'
import { useState } from 'react'
import { PAGINATION_DEFAULT } from '../../utils/constants'
import {
  useDeleteTraining,
  useGetDraftTrainings,
} from '../../redux/employees/hook/training'
import AddTraining from '../modal/hr-section/employee-training/add-training'

const EmployeeTrainersTab = () => {
  useEffect(() => {}, [])

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })
  const [trainingData, setTrainingData] = useState(null)
  const [tableType, setTableType] = useState('training')
  const [headerText, setHeaderText] = useState('')
  const [trainerChangeType, setTrainerChangeType] = useState('')

  const [edit, setEdit] = useState(false)
  const switchFunction = () => {
    if (tableType === 'training') {
      setTableType('table')
    } else {
      setTableType('training')
    }
  }

  const { mutateAsync: deleteTraining } = useDeleteTraining()

  const { data: trainings, refetch } = useGetDraftTrainings(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const tableConfig = {
    headers: ['Training Name', 'Training Period'],
    keys: ['module_name', 'period'],
    mobileHeader: {
      left: {
        title: 'Training Name',
        key: 'module_name',
      },
      right: {
        title: 'Training Period',
        key: 'period',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Edit',
      color: 'green',
      action: (id) => {
        let index = trainings.data.findIndex((item) => item.id === id)
        setTrainingData(trainings.data[index])
        setHeaderText('Edit Employee Training')
        setTrainerChangeType('edit')
        setEdit(true)
      },
    },
    {
      name: 'Delete',
      color: 'red',
      action: async (id) => {
        let index = trainings.data.findIndex((item) => item.id === id)
        await deleteTraining(trainings.data[index].id)
      },
    },
  ]

  return (
    <div className='flex flex-col'>
      {edit ? (
        <AddTraining
          isOpen={edit}
          closeModal={() => setEdit(false)}
          trainingData={trainingData}
          headerText={headerText}
          trainerChangeType={trainerChangeType}
          refetch={refetch}
        />
      ) : null}
      <hr className='divider mt-2 mb-1' />
      <DataTable
        data={trainings}
        tableConfig={tableConfig}
        actionConfig={actionConfig}
        updatePagination={(data) => setPagination(data)}
        computedActions={true}
        tableType={tableType}
        switchFunction={switchFunction}
        layoutSwitch={true}
        searchData={true}
        noCheck={true}
      />
    </div>
  )
}

export default EmployeeTrainersTab
